module.exports = __webpack_public_path__ + "static/media/logo-pc-default.3806787f.png";